import React, { useEffect, useState } from 'react';
import WspForm from './form';
import { useParams } from 'react-router-dom';
import Loading from '../../components/general/loading/loading';
import { asyncGetTemplateId } from '../../../services/commercialCrm.service';

const WspEdit = () => {
    const { idTemplate } = useParams();
    const [row, setRow] = useState<any>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [save, setSave] = useState<boolean>(false);

    useEffect(() => {
        if (row === undefined || save) {
            asyncGetTemplateId(idTemplate).then((body: any) => {
                if (body.items !== undefined) {
                    setRow(body.items);
                    setLoading(false);
                }
            });
        }
    }, [idTemplate, row, save]);

    return loading ? (
        <Loading />
    ) : (
        <WspForm
            idTemplate={idTemplate}
            templateInfo={row}
            onSave={(value: any) => setSave(value)}
        />
    );
};

export default WspEdit;
